import React from 'react';
import { Star } from 'lucide-react';
export function Testimonial() {
  return <section className="py-20 px-4 bg-[#1e2a38] text-white text-center" data-id="element-106">
      <div className="max-w-3xl mx-auto" data-id="element-107">
        <div className="flex justify-center gap-1 mb-6" data-id="element-108">
          {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-6 h-6 text-[#c9a07a] fill-current" data-id="element-109" />)}
        </div>
        <blockquote className="text-2xl md:text-4xl font-serif italic leading-relaxed mb-8" data-id="element-110">
          "A game-changer for my sleep. Finally, restful nights!"
        </blockquote>
        <cite className="text-lg text-[#c9a07a] font-medium not-italic" data-id="element-111">
          — Sarah K., 58
        </cite>
      </div>
    </section>;
}